<template>
  <div class="userList-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        placeholder="请输入用户id"
        clearable
        v-model="userParam.userID"
        size="small"
        @keyup.enter.native="refreshSearch"
        class="param-input">
      </el-input>
      <el-select
        placeholder="请选择操作类型"
        size="small"
        clearable
        v-model="userParam.operationType"
        @change="refreshSearch">
        <el-option
          v-for="item in operationTypeList"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <el-input
        placeholder="请输入操作内容"
        clearable
        v-model="userParam.content"
        size="small"
        @keyup.enter.native="refreshSearch"
        class="param-input">
      </el-input>
      <el-input
        placeholder="请输入操作人"
        clearable
        v-model="userParam.createdUser"
        size="small"
        @keyup.enter.native="refreshSearch"
        class="param-input">
      </el-input>
      <el-date-picker
        v-model="time"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        @change="changeTime">
      </el-date-picker>
      <el-button type="primary" size="small" @click="refreshSearch">
        搜索
      </el-button>
    </div>
    <!--表格数据-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable">
      <el-table-column
        prop="id"
        label="操作ID"
        align="center"
        fixed>
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="userID"
        label="玩家ID"
        align="center"
        width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.userID || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="operationType"
        label="操作类型"
        align="center">
        <template slot-scope="scope">
          <span>{{ operationTypeHandel(scope.row.operationType) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="reason"
        label="操作备注"
        align="center"
        width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.reason || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column width="400" prop="beforeContent" label="操作前内容" align="center">
        <template slot-scope="scope">
          <span>{{ operationTypeHandelByContent(scope.row.operationType, scope.row.beforeContent) }}</span>
        </template>
      </el-table-column>
      <el-table-column width="400" prop="afterContent" label="操作后内容" align="center">
        <template slot-scope="scope">
          <span>{{ operationTypeHandelByContent(scope.row.operationType, scope.row.afterContent) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdUser"
        label="操作人"
        align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.createdUser }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="操作时间"
        align="center"
        width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[5, 10, 20, 30, 50, 100]"
      :current-page="userParam.pageNumber"
      :page-size="userParam.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 1"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
  </div>
</template>
<script>
import baseConfig from "@/utils/serverUrlConfig";
import { changeTime } from "@/utils/global";
import API from "@/api";
export default {
  data() {
    return {
      dialogFormVisible: false,
      banTableData: [],
      uid: "",
      banTotal: "",
      banLoading: false,
      form: {
        phone: "",
      },
      imgUrl: baseConfig.imgUrl,
      // 表格数据加载动画
      loading: false,
      tableData: [],
      time: "",
      total: 0,
      idList: [],
      // 封禁理由列表参数
      params: {
        pageNumber: 1,
        pageSize: 10,
      },
      // 用户管理列表请求参数
      userParam: {
        uid: "",
        pageNumber: 1,
        pageSize: 5,
        start: "",
        end: "",
      },
      operationTypeList: [
        { value: 1, label: "媒体删除" },
        { value: 2, label: "媒体更新状态" },
        { value: 3, label: "媒体更新价格" },
        { value: 4, label: "媒体更新标题内容" },
        { value: 5, label: "媒体更新备注" },
        { value: 6, label: "用户追加金币" },
        { value: 7, label: "用户更新VIP类型" },
        { value: 8, label: "用户更新VIP新推广赠送免费到期时间" },
        { value: 9, label: "用户更新VIP过期时间" },
        { value: 10, label: "用户更新VIP充值等级" },
        { value: 11, label: "用户追加果币" },
        { value: 12, label: "回收用户充值金币" },
        { value: 13, label: "回收用户收益金币" },
      ],
    };
  },
  created() {
    // this.getUserLogList(this.userParam);
  },
  methods: {
    // 时间选择回掉
    changeTime(time) {
      if (time) {
        this.userParam.start = changeTime(time[0]);
        this.userParam.end = changeTime(time[1]);
      } else {
        this.userParam.start = "";
        this.userParam.end = "";
      }
      this.refreshSearch();
    },
    // 搜索对应列表
    refreshSearch() {
      this.userParam.pageNumber = 1;
      this.getUserLogList(this.userParam);
    },
    // 搜索对应列表
    search() {
      this.getUserLogList(this.userParam);
    },
    // 请求用户操作日志列表
    getUserLogList(obj) {
      this.loading = true;
      API.getUserLogList(obj)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.userParam.pageSize = size;
      this.userParam.pageNumber = 1;
      this.getUserLogList(this.userParam);
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.userParam.pageNumber = pageNumber;
      this.getUserLogList(this.userParam);
    },
    // 操作类型处理
    operationTypeHandel(type) {
      switch (type) {
        case 1:
          return "媒体删除"
        case 2:
          return "媒体更新状态"
        case 3:
          return "媒体更新价格"
        case 4:
          return "媒体更新标题内容"
        case 5:
          return "媒体更新备注"
        case 6:
          return "用户追加金币"
        case 7:
          return "用户更新VIP类型"
        case 8:
          return "用户更新VIP新推广赠送免费到期时间"
        case 9:
          return "用户更新VIP过期时间"
        case 10:
          return "用户更新VIP充值等级"
        case 11:
          return "用户追加果币"
        case 12:
          return "回收用户充值金币"
        case 13:
          return "回收用户收益金币"
        default:
          return "未知"
      }
    },
    // 操作类型处理
    operationTypeHandelByContent(operationType, content) {
      switch (operationType) {
        case 1:
          return content
        case 2:
          switch (content) {
            case "0":
              return "未审核"
            case "1":
              return "通过"
            case "2":
              return "审核失败"
            case "3":
              return "免费"
            default:
              return content
          }
        case 7:
          switch (content) {
            case "0":
              return "非VIP"
            case "1":
              return "体验会员"
            case "2":
              return "月VIP"
            case "3":
              return "季VIP"
            case "4":
              return "年VIP"
            case "5":
              return "永久"
            default:
              return content
          }
        default:
          return content
      }
    }
  },
};
</script>
<style lang="scss">
.el-message-box {
  .cancel_right {
    float: right;
    margin-left: 10px;
  }
}
</style>
<style scoped lang="scss">
.userList-box {
  .v-number {
    vertical-align: middle;
  }
  .view-details {
    margin-left: 10px;
    color: #e63765;
    font-size: 18px;
    cursor: pointer;
    vertical-align: middle;
    &:hover {
      color: #eb5f84;
    }
  }
  /deep/.col_layout {
    /deep/ div {
      display: flex;
      justify-content: center;
      padding-left: 50px;
      button {
        margin-left: auto;
      }
    }
  }
}
</style>
